import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../shared/HubLayout.css';
import { useMobileSubNav } from '../layout/MobileNavContext';
import { useHubScreen } from '../layout/useHubScreen';
import Rain, { RainActions } from './rain/Rain';
import Temperatures, { TemperaturesActions } from './temperatures/Temperatures';
import SectionDescription from '../shared/SectionDescription';

const SUB_PATHS = ['rain', 'temperatures'];

const SECTION_INFO = [
  { titleKey: 'rain_section_title',         textKey: 'rain_section_text' },
  { titleKey: 'temperatures_section_title', textKey: 'temperatures_section_text' },
];

export const ClimateHub = () => {
  const { t } = useTranslation();
  const { subTab, screen, setScreen } = useHubScreen();
  const navigate = useNavigate();
  const { setSubNav } = useMobileSubNav();

  const activeSubTab = Math.max(0, SUB_PATHS.indexOf(subTab));

  const subTabs = [t("rain"), t("temperatures")];

  const handleSubTabClick = (index) => navigate(`/climate/${SUB_PATHS[index]}`);

  useEffect(() => {
    setSubNav({ tabs: subTabs, activeTab: activeSubTab, onTabClicked: handleSubTabClick });
    return () => setSubNav(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSubTab, setSubNav]);

  return (
    <div className="hub">
      <div className="hub-content">
        <SectionDescription
          title={t(SECTION_INFO[activeSubTab].titleKey)}
          text={t(SECTION_INFO[activeSubTab].textKey)}
        />
        {activeSubTab === 0 && (
          <Rain
            screen={screen}
            setScreen={setScreen}
            actions={<RainActions screen={screen} setScreen={setScreen} />}
          />
        )}
        {activeSubTab === 1 && (
          <Temperatures
            screen={screen}
            setScreen={setScreen}
            actions={<TemperaturesActions screen={screen} setScreen={setScreen} />}
          />
        )}
      </div>
    </div>
  );
};

export default ClimateHub;
